import React, { useEffect, useState, useRef } from 'react'
import IconButton from '../CustomButtons/IconButton';
import Button from '../layout/aweLayout/Button';
import SortBothIcon from '../icons/SortBothIcon';
import Tooltip from '@mui/material/Tooltip';
import SearchIcon from '../icons/SearchIcon'
import PlusFillIcon from '../icons/PlusFillIcon'
import DownloadSquareIcon from '../icons/DownloadSquareIcon'
import DownloadButton from '../CustomButtons/DownloadButton';
import AWVCoderWorkBench from '../../assets/constants/AWVCoderWorkBenchRafservice.Instance';
import AWVApi from '../../assets/constants/AWVRafservice.Instance';
import QueryLetter from '../../assets/constants/QueryLetter.Instance';
import { Popover, Select, MenuItem } from '@mui/material'
import FilterIcon from '../icons/FilterIcon'
import ColumnLinesIcon from '../icons/ColumnLinesIcon'
import SmallArrowLeftIcon from '../icons/SmallArrowLeftIcon';
import SmallArrowRightIcon from '../icons/SmallArrowRightIcon';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { connect } from 'react-redux';
import { currentRoute, currentAWERightSidebarCloseDatatableReload } from '../../store/actions';
import { toast } from 'react-toastify';

const CustomAweDatatable = (props) => {
    const arrowRef = useRef()
    const { titleName = '', downloadFileName = 'download', statusOptions = [],
        columns, urlLink, searchBox = false, showColumnBtn = false,
        downloadBtn = false, filterBox = false, addNewEvent = '',
        colSpan = 2, pagination = false, buttonWrap, downloadBtnReport, downloadClaimURL, downloadClaimFileName } = props;
    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [filterShow, setFilterShow] = useState(null);
    const [columnShow, setColumnShow] = useState(null);
    const [customFilterAttribute, setCustomFilterAttribute] = useState({});
    const [customFilterApply, setCustomFilterApply] = useState(false);
    const [searchFilter, setSearchFilter] = useState('');
    const [sortColumnName, setSortColumnName] = useState('');
    const [sortName, setSortName] = useState('');
    const [columnsToFilter, setColumnsToFilter] = useState([]);
    const [columnsToShows, setColumnsToShows] = useState([]);
    const open = Boolean(filterShow);
    const openColumn = Boolean(columnShow);
    const id = open ? 'simple-popover' : undefined;
    const idColumn = openColumn ? 'simple-popover' : undefined;
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [maxPages, setMaxPages] = useState();
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const [claimsData, setClaimsData] = useState([]);

    useEffect(() => {
        if (props.aweRightSidebarCloseDatatableReload && props.aweRightSidebarCloseDatatableReload == true) {
            loadDatatable();
            loadClaimsData()
            props.currentAWERightSidebarCloseDatatableReload(false);
        }
    }, [props.aweRightSidebarCloseDatatableReload]);

    useEffect(() => {
        // console.log('CustomAweDatatable');
        // console.log({ urlLink });
        loadDatatable();
        loadClaimsData()
        var filterColumn = [];
        var showColumns = [];
        var updatedFilter = { ...customFilterAttribute };
        columns && columns.map((elementColumn, indexColumn) => {
            if (elementColumn?.options?.search == true) {
                filterColumn.push(elementColumn.name);
            }
            if (elementColumn?.options?.showColumn == true) {
                showColumns.push(elementColumn.name);
            }
            if (elementColumn?.options?.filterSelectedOption && elementColumn?.options?.filterSelectedOption != '') {
                const name = elementColumn?.name;
                const value = elementColumn?.options?.filterSelectedOption;
                if (value && value != '') {
                    updatedFilter[name] = value;
                }
            }
        });
        setColumnsToFilter(filterColumn);
        setColumnsToShows(showColumns);

        if (updatedFilter) {
            setCustomFilterAttribute(updatedFilter);
            setCustomFilterApply(true);
        }

    }, [urlLink]);

    const handleNextPage = () => {
        if (currentPage < maxPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleSort = (key) => {
        if (sortColumnName === key && sortName === 'asc') {
            setSortColumnName(key);
            setSortName('desc');
        } else {
            setSortColumnName(key);
            setSortName('asc');
        }
    };

    const handleFilterChange = (event) => {
        setCustomFilterApply(false);
        const name = event?.target?.name;
        const value = event?.target?.value;
        var updatedFilter = { ...customFilterAttribute };
        if (value && value != '') {
            updatedFilter[name] = value;
        } else {
            delete updatedFilter[name];
        }
        setCustomFilterAttribute(updatedFilter);
    };

    const customFilteredData = dataSource.filter((item) => {
        if (Object.keys(customFilterAttribute).length === 0) return true;
        if (customFilterApply == false) return true;

        return Object.entries(customFilterAttribute).every(([key, value]) => {
            if (props?.customFilter && Array.isArray(props?.customFilter) && props?.customFilter.length > 0 && props?.customFilter.toString().toLowerCase().includes(key?.toLowerCase())) {
                if (value == 'Yes') {
                    return item.hasOwnProperty(key) && item[key] != '';
                } else if (value == 'No') {
                    return item.hasOwnProperty(key) && item[key] == '';
                } else {
                    return item.hasOwnProperty(key) && (item[key] == '' || item[key] != '')
                }
                return item.hasOwnProperty(key) && item[key]?.toString().toLowerCase().includes(value?.toLowerCase());
            } else {
                return item.hasOwnProperty(key) && item[key]?.toString().toLowerCase().includes(value?.toLowerCase());
            }
        });
    });

    const sortedData = customFilteredData.slice().sort((a, b) => {
        if (sortColumnName) {
            const keyA = a[sortColumnName];
            const keyB = b[sortColumnName];

             // Handle null values
             if (keyA === null || keyB === null) {
                if (keyA === keyB) return 0;
                if (keyA === null) return sortName === 'asc' ? 1 : -1;
                if (keyB === null) return sortName === 'asc' ? -1 : 1;
            }

            // Regular comparison
            if (keyA < keyB) return sortName === 'asc' ? -1 : 1;
            if (keyA > keyB) return sortName === 'asc' ? 1 : -1;
        }

        return 0;
    });

    const filteredData = sortedData.filter((item) => {
        if (!searchFilter) return true;

        return Object.entries(item).some(([key, value]) => {
            if (value === null) return false;
            return columnsToFilter.includes(key) && value.toString().toLowerCase().includes(searchFilter.toLowerCase());
        });
    });

    const currentData = filteredData.slice(startIndex, endIndex);

    const customFilterSubmit = () => {
        setCustomFilterApply(true);
        // setFilterShow(null);
    };

    const customFilterReset = () => {
        var updatedFilter = { ...customFilterAttribute };
        for (const key in updatedFilter) {
            updatedFilter[key] = '';
        }
        setCustomFilterAttribute(updatedFilter);
        setCustomFilterApply(false);
    };

    useEffect(() => {
        if (customFilterApply == true) {
            setFilterShow(null);
        }
    }, [customFilterApply]);

    const customColumnShowReset = () => {
        var showColumns = [];
        columns && columns.map((elementColumn, indexColumn) => {
            if (elementColumn?.options?.showColumn == true) {
                showColumns.push(elementColumn.name);
            }
        });
        setColumnsToShows(showColumns);
    };

    const handleClose = () => {
        setFilterShow(null);
    };

    const handleClick = (event) => {
        setFilterShow(event.currentTarget);
    };

    const handleColumnClose = () => {
        setColumnShow(null);
    };

    const handleColumnClick = (event) => {
        setColumnShow(event.currentTarget);
    };

    const handleChangeShowColumn = (event) => {
        setColumnsToShows((prevColumnsToShows) => {
            const updatedColumns = [...prevColumnsToShows];
            if (event.target.checked) {
                updatedColumns.push(event.target.name);
            } else {
                const index = updatedColumns.indexOf(event.target.name);
                if (index !== -1) {
                    updatedColumns.splice(index, 1);
                }
            }
            return updatedColumns;
        });
    };

    useEffect(() => {

    }, [columnsToShows]);

    useEffect(() => {
        setMaxPages(Math.ceil(filteredData.length / pageSize));
    }, [filteredData, pageSize]);

    const handlePageSizeChange = (e) => {
        const newPageSize = parseInt(e.target.value);
        setPageSize(newPageSize);
        setMaxPages(Math.ceil(filteredData.length / newPageSize));
        setCurrentPage(1);
    };

    const loadClaimsData = () => {
        if (downloadBtnReport && downloadBtnReport == true) {
            AWVApi.get(downloadClaimURL)
                .then(res => {
                    if (props.yearSelect != '' && props.lobSelect != '' && res.data?.errorType && res.data?.errorType != '') {
                        setClaimsData([]);
                        // toast.error(res.data?.errorMessage);
                    } else {
                        setClaimsData(res.data);
                    }
                    // setIsLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setClaimsData([]);
                    // setIsLoading(false);
                })
        }
    }
    const loadDatatable = () => {
        setIsLoading(true);
        if (props.UrlAxios && props.UrlAxios == 'AWVApi') {
            AWVApi.get(urlLink)
                .then(res => {
                    if (props.yearSelect != '' && props.lobSelect != '' && res.data?.errorType && res.data?.errorType != '') {
                        setDataSource([]);
                        toast.error(res.data?.errorMessage);
                    } else {
                        setDataSource(res.data);
                    }
                    setIsLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setDataSource([]);
                    setIsLoading(false);
                })
        } else if (props.UrlAxios && props.UrlAxios == 'AWVApiHCC') {
            AWVApi.get(urlLink)
                .then(res => {
                    if (props.yearSelect != '' && props.lobSelect != '' && res.data?.errorType && res.data?.errorType != '') {
                        setDataSource([]);
                        toast.error(res.data?.errorMessage);
                    } else {
                        setDataSource(res.data);
                    }
                    setIsLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setDataSource([]);
                    setIsLoading(false);
                })
        } else if (props.UrlAxios && props.UrlAxios == 'QueryLetter') {
            QueryLetter.get(urlLink)
                .then(res => {
                    setDataSource(res.data);
                    setIsLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setDataSource([]);
                    setIsLoading(false);
                })
        } else {
            AWVCoderWorkBench.get(urlLink)
                .then(res => {
                    if (props.yearSelect != '' && props.lobSelect != '' && res.data?.errorType && res.data?.errorType != '') {
                        setDataSource([]);
                        toast.error(res.data?.errorMessage);
                    } else {
                        setDataSource(res.data);
                    }
                    setIsLoading(false);
                })
                .catch(err => {
                    console.log(err);
                    setDataSource([]);
                    setIsLoading(false);
                })
        }

    }

    const exportData = () => {
        var labelArray = [];
        var labelNameMap = new Map()
        console.log("columns..", columns)
        columns.forEach((column) => {
            // labelArray.push(name.label)
            var label = column.label;
            var name = column.name;

            labelArray.push(label);
            labelNameMap.set(name, label);

        });
        var matchedValuesArray = [];
        dataSource.forEach((data, index) => {
            var labelToAdd = ''
            // alert(Object.entries(data))
            var matchedValuesObject = {};
            Object.entries(data).forEach(([label, value]) => {
                // if (labelNameMap.get(label) && labelNameMap.get(label) === label) {
                if (labelNameMap.has(label)) {
                    //         labelToAdd =labelNameMap.get(label)

                    // //  alert(labelToAdd)
                    //     matchedValuesArray.push({
                    //         [labelToAdd]: value,
                    //     });
                    // console.log("valueaaaaaaaaaaaaaaaaaaa..", label)
                    if (downloadFileName == 'diagonsis_code') {
                        if (label == 'dx_code') {
                            value = value.slice(0, value.indexOf('-'));
                        } else if (label == 'dx_description') {
                            value = data?.dx_code.split(/[-]+/).pop()
                        } else if (label == 'model_1') {
                            value = value.slice(0, value.indexOf('-'));
                        } else if (label == 'model_1_description') {
                            value = data?.model_1.split(/[-]+/).pop()
                        } else if (label == 'model_2') {
                            value = value.slice(0, value.indexOf('-'));
                        } else if (label == 'model_2_description') {
                            value = data?.model_2.split(/[-]+/).pop()
                        }
                    }

                    var newLabel = labelNameMap.get(label);
                    matchedValuesObject[newLabel] = value;

                }
            });
            matchedValuesArray.push(matchedValuesObject);
        });
        // alert(JSON.stringify(matchedValuesArray))
        if (matchedValuesArray && Array.isArray(matchedValuesArray) && matchedValuesArray.length > 0) {
            const csvContent = 'data:text/csv;charset=utf-8,' + convertToCsv(matchedValuesArray);
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            link.setAttribute('download', downloadFileName + '.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.log('Error: Conditions not present');
        }


    };


    const exportClaimsData = () => {
        // alert(JSON.stringify(matchedValuesArray))
        if (claimsData && Array.isArray(claimsData) && claimsData.length > 0) {
            const csvContent = 'data:text/csv;charset=utf-8,' + convertToCsv(claimsData);
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            link.setAttribute('download', downloadClaimFileName + '.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            // toast.error("Matching claims not present");
            console.log('Error: Matching claims not present');
        }
    };

    const convertToCsv = (data) => {
        const headers = Object.keys(data[0]);
        const csvRows = [];
        csvRows.push(headers.join(','));

        for (const row of data) {
            const values = headers.map((header) => {
                return `"${row[header]}"`;
            });
            csvRows.push(values.join(','));
        }

        return csvRows.join('\n');
    };

    return (
        <>
            <div className="card_header flex_item_cb mb20 flex-wrap">
                <h2 className="fs18 card-title">{titleName}</h2>
                <div className="flex_item_ce flex-wrap">
                    {statusOptions && statusOptions.length > 0 &&
                        <ul className="flex_item_ce gap10">
                            {statusOptions && statusOptions.map((statusOption, index) => (
                                <li key={index}>
                                    <Tooltip title={statusOption.text} arrow placement="top">
                                        <div>
                                            <span className={`badge flex_item_cs d-flex ${statusOption.colorClass}`}>
                                                {statusOption.icon}
                                                {statusOption.count}
                                            </span>
                                        </div>
                                    </Tooltip>
                                </li>
                            ))}
                        </ul>
                    }

                    {searchBox && searchBox == true &&
                        <div className="search_box minw300">
                            <div className="form-group mb-0">
                                <div className="form-control gap10 flex_item_cs">
                                    <IconButton className={"lh-1"} buttonType={"default"}>
                                        <SearchIcon className="w16" />
                                    </IconButton>
                                    <input type="search" name="search" className="" placeholder="Search" onChange={(e) => setSearchFilter(e.target.value)} />
                                </div>
                            </div>
                        </div>
                    }

                    <ul className="flex_item_ce gap10">
                        {downloadBtn && downloadBtn === true && (
                            dataSource.length > 0 ?(
                                <li>
                                    <Tooltip title={'Download CSV'} arrow placement="top">
                                        <div>
                                            <IconButton className={"link_primary"} buttonType={"default"} onClick={() => exportData()}>
                                                <DownloadSquareIcon className="w24" />
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                </li>
                            ):(
                                <li>
                                    <Tooltip title={'Download CSV'} arrow placement="top">
                                        <div>
                                            <IconButton className={"link_primary"} disabled={false} buttonType={"default"} onClick={() => exportData()} >
                                                <DownloadSquareIcon className="w24" style={{ color: '#b8dedf' }} />
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                </li>
                            )
                        )}
                        {filterBox && filterBox == true &&
                            <li className="filter_dropdown">
                                <Tooltip title={'Filter'} arrow placement="top">
                                    <div>
                                        <IconButton aria-describedby={id} onClick={handleClick} type="button" className={"link_primary"} buttonType={"default"}>
                                            <FilterIcon className="w24" />
                                        </IconButton>
                                    </div>
                                </Tooltip>
                                <Popover
                                    id={id}
                                    open={open}
                                    anchorEl={filterShow}
                                    onClose={handleClose}
                                    placement="top-end"
                                    className="filter_dropdown_menu"
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    modifiers={[
                                        {
                                            name: 'flip',
                                            enabled: true,
                                            options: {
                                                altBoundary: true,
                                                rootBoundary: 'document',
                                                padding: 8,
                                            },
                                        },
                                        {
                                            name: 'preventOverflow',
                                            enabled: true,
                                            options: {
                                                altAxis: true,
                                                altBoundary: true,
                                                tether: true,
                                                rootBoundary: 'document',
                                                padding: 8,
                                            },
                                        },
                                        {
                                            name: 'arrow',
                                            enabled: true,
                                            options: {
                                                element: arrowRef,
                                            },
                                        },
                                    ]}
                                >
                                    <div className="flex_item_cb mb-3">
                                        <h2 className="fs14">Filter</h2>
                                        <div>
                                            <Button type="button" onClick={() => customFilterSubmit()} className="text-primary fs14 mr-2" buttonType={"default"}>Apply</Button>
                                            <Button type="button" onClick={() => customFilterReset()} className="text-primary fs14" buttonType={"default"}>Clear</Button>
                                        </div>
                                    </div>
                                    {columns && columns.filter((elementCol) => {
                                        return elementCol?.options?.filter == true;
                                    }).map((elementColumn, indexColumn) => {
                                        return (
                                            <div key={indexColumn} className='form-group'>
                                                <label htmlFor="" className="text_c3A3C40 fs13 mb-2">
                                                    {elementColumn?.options?.filterName && elementColumn?.options?.filterName != '' ?
                                                        elementColumn?.options?.filterName
                                                        :
                                                        elementColumn?.label
                                                    }
                                                </label>
                                                {elementColumn?.options?.filterType && elementColumn?.options?.filterType == 'selectStatus' ?
                                                    <Select
                                                        displayEmpty
                                                        className="custom_select"
                                                        name={elementColumn?.name}
                                                        value={customFilterAttribute?.[elementColumn?.name]}
                                                        onChange={(e) => handleFilterChange(e)}
                                                        inputProps={{ 'aria-label': 'Without label' }}
                                                    >
                                                        <MenuItem value="">
                                                            <em>All</em>
                                                        </MenuItem>
                                                        {statusOptions && statusOptions.map((statusOption, index) => (
                                                            <MenuItem value={statusOption.value} key={index}>
                                                                {statusOption.text}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                    : elementColumn?.options?.filterType && elementColumn?.options?.filterType == 'selectCustom' ?
                                                        <Select
                                                            displayEmpty
                                                            className="custom_select"
                                                            name={elementColumn?.name}
                                                            onChange={(e) => handleFilterChange(e)}
                                                            value={customFilterAttribute?.[elementColumn?.name]}
                                                            inputProps={{ 'aria-label': 'Without label' }}
                                                        >
                                                            {elementColumn?.options?.optionList && elementColumn?.options?.optionList.map((option, index) => (
                                                                <MenuItem value={option.value} key={index}>
                                                                    {option.text}
                                                                </MenuItem>
                                                            ))}
                                                        </Select>
                                                        : elementColumn?.options?.filterType && elementColumn?.options?.filterType == 'select' ?
                                                            <Select
                                                                displayEmpty
                                                                className="custom_select"
                                                                name={elementColumn?.name}
                                                                onChange={(e) => handleFilterChange(e)}
                                                                value={customFilterAttribute?.[elementColumn?.name]}
                                                                inputProps={{ 'aria-label': 'Without label' }}
                                                            >
                                                                <MenuItem value="">
                                                                    <em>All</em>
                                                                </MenuItem>
                                                            </Select>
                                                            : elementColumn?.options?.filterType && elementColumn?.options?.filterType == 'date' ?
                                                                <input
                                                                    type="date"
                                                                    value={customFilterAttribute?.[elementColumn?.name]}
                                                                    name={elementColumn?.name}
                                                                    onChange={(e) => handleFilterChange(e)}
                                                                    className="form-control"
                                                                />
                                                                :
                                                                <input
                                                                    type="search"
                                                                    value={customFilterAttribute?.[elementColumn?.name]}
                                                                    name={elementColumn?.name}
                                                                    onChange={(e) => handleFilterChange(e)}
                                                                    className="form-control"
                                                                />
                                                }
                                            </div>
                                        )
                                    }
                                    )}
                                </Popover>
                            </li>
                        }
                        {showColumnBtn && showColumnBtn == true &&
                            <li className="filter_dropdown">
                                <Tooltip title={'Show Columns'} arrow placement="top">
                                    <div>
                                        <IconButton aria-describedby={idColumn} onClick={handleColumnClick} type="button" className={"link_primary"} buttonType={"default"}>
                                            <ColumnLinesIcon className="w24" />
                                        </IconButton>
                                    </div>
                                </Tooltip>
                                <Popover
                                    id={idColumn}
                                    open={openColumn}
                                    anchorEl={columnShow}
                                    onClose={handleColumnClose}
                                    placement="top-end"
                                    className="filter_dropdown_menu"
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    modifiers={[
                                        {
                                            name: 'flip',
                                            enabled: true,
                                            options: {
                                                altBoundary: true,
                                                rootBoundary: 'document',
                                                padding: 8,
                                            },
                                        },
                                        {
                                            name: 'preventOverflow',
                                            enabled: true,
                                            options: {
                                                altAxis: true,
                                                altBoundary: true,
                                                tether: true,
                                                rootBoundary: 'document',
                                                padding: 8,
                                            },
                                        },
                                        {
                                            name: 'arrow',
                                            enabled: true,
                                            options: {
                                                element: arrowRef,
                                            },
                                        },
                                    ]}
                                >
                                    <div className="flex_item_cb mb-3">
                                        <h2 className="fs14">Show Columns</h2>
                                        <Button type="button" onClick={() => customColumnShowReset()} className="text-grey-600 fs14" buttonType={"default"}>Reset</Button>
                                    </div>
                                    {columns && columns.map((elementColumn, indexColumn) => {
                                        return (
                                            <div key={indexColumn} >
                                                <FormControlLabel
                                                    className="custom_checkbox m-0 gap8 text-grey-900"
                                                    control={
                                                        <Checkbox
                                                            className="p-0"
                                                            type="checkbox"
                                                            value={elementColumn?.name}
                                                            checked={columnsToShows.includes(elementColumn?.name)}
                                                            name={elementColumn?.name}
                                                            onChange={handleChangeShowColumn}
                                                            text="ss"
                                                            size="small"
                                                        />
                                                    }
                                                    label={<span className="fs14 fw400 flex_item_cc gap8">{elementColumn?.label}</span>}
                                                />
                                            </div>
                                        )
                                    })
                                    }
                                </Popover>
                            </li>
                        }
                        {addNewEvent && addNewEvent != '' &&
                            <li>
                                {/* <Tooltip title={'Add'} arrow placement="top">
                                    <div> */}
                                {addNewEvent}
                                {/* </div>
                                </Tooltip> */}
                            </li>
                        }
                        {downloadBtnReport && downloadBtnReport === true && (
                            claimsData.length > 0 ? (
                                <li>
                                    <Tooltip title={'Download Claim Report'} arrow placement="top">
                                        <div>
                                            <IconButton className={"link_primary"} buttonType={"default"} onClick={() => exportClaimsData()}>
                                                <DownloadButton color={'rgb(46, 147, 147)'} />
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                </li>
                            ) : (
                                <li>
                                    <Tooltip title={'Download Claim Report'} arrow placement="top">
                                        <div>
                                            <IconButton className={"link_primary"} buttonType={"default"} onClick={() => exportClaimsData()}>
                                                <DownloadButton color={'#b8dedf'} />
                                            </IconButton>
                                        </div>
                                    </Tooltip>
                                </li>
                            )
                        )}

                        {buttonWrap && buttonWrap != '' &&
                            <li>
                                {buttonWrap}
                            </li>
                        }
                    </ul>
                </div>
            </div>
            <div className={'mui_custom_table'} style={{ minHeight: "100px" }}>
                <div class="table-responsive custom-scrollbar">
                    <table class="table" id={props.id ?? ''}>
                        <thead>
                            <tr>
                                {columns && columns.filter((elementCol) => {
                                    return columnsToShows.includes(elementCol?.name);
                                }).map((elementColumn, indexColumn) => (
                                    <th scope="col"
                                        active={sortColumnName === elementColumn?.name}
                                        direction={sortColumnName === elementColumn?.name ? sortName : 'asc'}
                                        onClick={() => handleSort(elementColumn?.name)}
                                        className={`${elementColumn?.options?.sort && elementColumn?.options?.sort == true ? "sort_th" : "sort_th"}`} key={indexColumn} style={{ width: (elementColumn?.options && elementColumn?.options?.width) ? elementColumn?.options?.width : '100px', minWidth: (elementColumn?.options && elementColumn?.options?.width) ? elementColumn?.options?.width : '100px', maxWidth: (elementColumn?.options && elementColumn?.options?.width) ? elementColumn?.options?.width : '100px' }}>
                                        <div className="flex_item_cs gap4">
                                            {elementColumn?.label}
                                            {elementColumn?.options?.sort && elementColumn?.options?.sort == true ?
                                                <IconButton buttonType={"default"} className={"table_sort_icon lh_1"} type="button">
                                                    <SortBothIcon className="w16" />
                                                </IconButton>
                                                :
                                                <></>
                                            }
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {isLoading && isLoading == true &&
                                <tr >
                                    <td colSpan={colSpan}>
                                        <div className='text-center mt-2 mb-2'>Loading...</div>
                                    </td>
                                </tr>
                            }
                            {isLoading != true && currentData && currentData.length == 0 &&
                                <tr >
                                    <td colSpan={colSpan}>
                                        <div className='text-center mt-2 mb-2'>Sorry, there is no matching data to display</div>
                                    </td>
                                </tr>
                            }
                            {currentData && currentData.length > 0 && currentData.map((elementRow, indexRow) => (
                                <tr key={indexRow}>
                                    {columns && columns.filter((elementCol) => {
                                        return columnsToShows.includes(elementCol?.name);
                                    }).map((elementColumn, indexColumn) => (
                                        <td key={indexColumn} style={{ width: (elementColumn?.options && elementColumn?.options?.width) ? elementColumn?.options?.width : '100px' }}>
                                            {elementColumn?.options?.customBodyRender && elementColumn?.options?.otherColumnName == 'all' ?
                                                elementColumn?.options?.customBodyRender(elementRow?.[elementColumn?.name], elementRow, indexRow)
                                                : elementColumn?.options?.customBodyRender && elementColumn?.options?.customBodyRender != '' ?
                                                    elementColumn?.options?.customBodyRender(elementRow?.[elementColumn?.name], elementRow?.[elementColumn?.options?.otherColumnName])
                                                    : elementColumn?.options?.customBodyRender ?
                                                        elementColumn?.options?.customBodyRender(elementRow?.[elementColumn?.name])
                                                        :
                                                        elementRow?.[elementColumn?.name]
                                            }
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            {pagination && pagination == true &&
                <div className="pagination-wrap flex_item_ce mt-4">
                    <div className="flex_item_ce gap4">
                        <p className="mb-0">Rows per page:</p>
                        <Select
                            value={pageSize}
                            onChange={handlePageSizeChange}
                            className="pagination_select"
                            inputProps={{ 'aria-label': 'Without label' }}
                        >
                            {[10, 20, 25, 50, 100].map((size) => (
                                <MenuItem key={size} className="text-grey-800" value={size}>
                                    {size}
                                </MenuItem>
                            ))}
                        </Select>
                    </div>
                    <div className="flex_item_ce gap10">
                        <IconButton
                            onClick={handlePrevPage}
                            disabled={(currentPage && currentPage > 1) ? false : true}
                            className={"btn-white flex_item_cc p-0"}
                            style={{ width: '24px', height: "20px" }}
                        >
                            <SmallArrowLeftIcon className="w16" />
                        </IconButton>
                        <p className="mb-0 text-grey">
                            {currentPage}
                            <span className="text-grey-800">
                                /{maxPages}
                            </span>
                        </p>
                        <IconButton
                            onClick={handleNextPage}
                            disabled={(maxPages && currentPage != maxPages) ? false : true}
                            className={"btn-white flex_item_cc p-0"}
                            style={{ width: '24px', height: "20px" }}
                        >
                            <SmallArrowRightIcon className="w16" />
                        </IconButton>
                    </div>
                </div>
            }
        </>
    );

}
const mapStateToProps = (state) => {
    return {
        yearSelect: state.moduleFilter.yearSelect,
        providerGroupSelect: state.moduleFilter.providerGroupSelect,
        projectGroupSelect: state.moduleFilter.projectGroupSelect,
        lobSelect: state.moduleFilter.lobSelect,
        aweRightSidebarCloseDatatableReload: state.moduleFilter.aweRightSidebarCloseDatatableReload
    };
}
export default connect(mapStateToProps, { currentAWERightSidebarCloseDatatableReload })(CustomAweDatatable);